export interface Person_Amozesh_Interface {
  id:number,
  person_id:number,
  date_starrt:String,
  date_end:String,

  sarFaslAmozeshi_id:number,
  sarFaslAmozeshiTitle:String,

  dorehAmoozeshi_id:number,
  dorehAmoozeshiTitle:String,

  modat:number,
  bargozarKonnadeh:String,
  image:String,
}

export function Empty_Person_Amozesh_Interface(){
  return{
    id:0,
    person_id:0,
    date_starrt:'',
    date_end:'',
    sarFaslAmozeshiTitle:'',
    dorehAmoozeshiTitle:'',
    sarFaslAmozeshi_id:0,
    dorehAmoozeshi_id:0,
    modat:0,
    bargozarKonnadeh:'',
    image:'',
  }
}
